  <div>
       <div style="margin-left: 80%; margin-top: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
        printSectionId="print-section2" ngxPrint>
        print
    </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>
        <!-- id="print-button"  -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%;"
            mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
        </button>


        <!-- <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button> -->

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>

        <!-- <div class="footer"></div> -->

    </div>
    <div class="container" id="print-section1">
        <ng-container *ngIf="indetail && !datewise && !officerep">
            <!-- <div style=""> -->
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th colspan="2">
                            <p>Vivek Saptahik</p>
                        </th>
                        <th colspan="5">
                            <p>Issue Seller Repwise Indetail. Registreation Report</p>
                        </th>
                        <th colspan="2">In Detail</th>
                        <!-- <th colspan="2"></th> -->
                        <!-- <th colspan="3"></th> -->
                        <th colspan="5">Date : {{ today | date:"dd-MM-yyyy" }}</th>
                        <th colspan="3">Page No
                            <!-- <h5 class="page-number"></h5> -->
                        </th>
                    </tr>
                    <tr>
                        <th colspan="2">
                            <div>Date. From : {{ start_date | date:"dd-MM-yyyy"}}</div>
                        </th>
                        <th colspan="2" class="leftAlign">
                            <div>To : {{ end_date | date:"dd-MM-yyyy"}}</div>
                        </th>
                        <th colspan="3" class="leftAlign">
                            <div>Issue/Grantha Category : {{ issue_cat }}</div>
                        </th>
                        <th colspan="2" class="leftAlign">
                            <div>Issue Date : {{ issueDate | date:"dd-MM-yyyy"}}
                            </div>
                        </th>
                        <th colspan="5">Issue Name : {{ issue_name }}</th>
                        <th colspan="3">
                        </th>
                    </tr>
                    <tr>
                        <th>Sr.<br />No</th>
                        <th>Booking<br />Date</th>
                        <th>Booking<br />No</th>
                        <th colspan="2">Issue Seller Name</th>
                        <!-- <th>Customer<br />Name</th> -->
                        <th>Representative<br />Name</th>
                        <!-- <th>Mobile No</th> -->
                        <th>Office<br />Rep. Name</th>
                        <th>RO Number<br />Instruction</th>
                        <!-- <th></th> -->
                        <th>Issue Copies</th>
                        <th>Issue.<br />Amt.</th>
                        <th>Net<br /> Amt.</th>
                        <th>GST 5%</th>
                        <th>Total<br />Amt.</th>
                        <th>Received<br />Amt.</th>
                        <th>Receipt
                            No.<br />and
                            Date</th>
                        <th>Pending<br />Amt.</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of inDetailsRegReport1; let i = index">
                        <tr>
                            <td><span>{{ i + 1 }}</span></td>
                            <td> {{item.booking_date}}</td>
                            <td>
                               {{item.booking_no}}
                            </td>
                            <td colspan="2">
                                {{item.issue_seller_name}}
                            </td>
                            <!-- <td>{{ item.cust_name }}</td> -->
                            <td>
                                {{item.rep_name}}
                            </td>
                            <!-- <td class="right"><span>{{ item['rep_mob_no'] }}</span></td> -->
                            <td>
                                {{ item['off_rep_name'] }}
                            </td>
                            <td>
                                {{ item['ro_no'] }}  
                            </td>
                            <!-- <td></td> -->
                            <td>
                            {{ item['advtsize'] }}
                            </td>
                            <td class="right"><span>{{ item['issue_seller_amt'] }}</span></td>
                            <td class="right"><span>{{ item['amount'] }}</span></td>
                            <td class="right"><span>{{ toInt(item['sgst']) + toInt(item['cgst']) }}</span></td>
                            <td class="right"><span>{{ item['igst'] }}</span></td>
                            <td class="right"><span>{{ item['part_pymt_amt'] }}</span></td>
                            <td>{{ item['rep_rcpt_no'] }}
                                <ng-container *ngIf="item['rcpt_date'] != '0000-00-00'">
                                    <br />{{ item['rcpt_date'] | date:"dd-MM-yyy" }}
                                </ng-container>
                            </td>
                            <td class="right"><span>{{ item['part_pymt_remaning_amt'] }}</span></td>
                        </tr>
                    </ng-container>
                    <tr>
                        <td></td>
                        <!-- <td></td> -->
                        <td colspan="4" class="boldText">
                            <p>Total No of Advt : <b>{{ this.inDetailsRegReportTotal.total_advt }}</b></p>
                        </td>
                        <!-- <td colspan="2"></td> -->
                        <!-- <td></td> -->
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.advt_total }}</b></span></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.net_amt }}</b></span></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.gst }}</b></span></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.total_amt }}</b></span></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.rcvd_amt }}</b></span></td>
                        <td></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.pndg_amt }}</b></span></td>
                    </tr>
                </tbody>
            </table>
            <!-- </div> -->
        </ng-container>
       
    </div>
 <div *ngIf="type === 'Represantative Briefly'">
  <div id="print-section" style="margin-top: 50px; margin-left: 20px;">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="1" class="br-top br-right br-bottom no-border">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
          <th colspan="2" class="br-top br-right br-bottom no-border">अंकाचे नाव: {{ newissuedatepp }}</th>
          <th colspan="2" class="br-top br-right br-bottom no-border">Representative Briefly</th>
          <th colspan="2" class="br-top br-right br-bottom no-border">अंकाचे कॅटेगरी: {{ issue_cat }}</th>
          <th colspan="2" class="br-top br-right br-bottom no-border">Date: From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}</th>
          <th class="br-top br-bottom no-border">दिनांक: {{ today1 }}</th>
          <th class="br-top br-bottom">पृष्ठ क्र : 1</th>
        </tr>
        <tr>
          <th>Sr</th>
          <th>Issue Seller Name</th>
          <th>Representative</th>
          <th>Copies</th>
          <th class="text-end">Issue Seller Amt</th>
          <th class="text-end">Net Amt</th>
          <th class="text-end">Before GST</th>
          <th class="text-end">GST Amt</th>
          <th class="text-end">Total Amt</th>
          <th class="text-end">Receive Amt</th>
          <th class="text-end">Pending Amt</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item1 of inDetailsRegReportrep; let repIndex = index">
          <tr class="group-header">
            <td colspan="3">Representative Name: {{ item1.rep_name }}</td>
            <td colspan="3">Mobile Number: {{ item1.rep_mob_no }}</td>
            <td colspan="6"></td>
          </tr>

          <ng-container *ngFor="let item of item1.issue_data; let i = index">
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ item.issue_seller_name }}</td>
              <td>{{ item.rep_name }}</td>
              <td>{{ item.isuuecopies }}</td>
              <td class="text-end">{{ item.issue_amt }}</td>
              <td class="text-end">{{ item.amount }}</td>
              <td class="text-end">{{ item.beforegst_amt }}</td>
              <td class="text-end">{{ item.gst }}</td>
              <td class="text-end">{{ item.total_amount }}</td>
              <td class="text-end">{{ item.pymt_rcv_amt }}</td>
              <td class="text-end">{{ item.remaining_amt }}</td>
            </tr>
          </ng-container>

          <tr class="group-total">
            <td>{{ item1.issue_data.length }}</td>
            <td colspan="3" class="text-center fw-bold">एकूण</td>
            <td class="text-end fw-bold">{{ item1.total_advt_amount }}</td>
            <td class="text-end fw-bold">{{ item1.total_discounted_amt }}</td>
            <td class="text-end fw-bold">{{ item1.total_before_gst }}</td>
            <td class="text-end fw-bold">{{ item1.total_gst }}</td>
            <td class="text-end fw-bold">{{ item1.total_amt }}</td>
            <td class="text-end fw-bold">{{ item1.total_rcv }}</td>
            <td class="text-end fw-bold">{{ item1.total_pending }}</td>
          </tr>
        </ng-container>
      </tbody>

   <tfoot>
  <tr class="grand-total">
    <td colspan="3" class="text-center fw-bold">Final Total</td>
    <td class="text-end fw-bold">{{ copies }}</td>
    <td class="text-end fw-bold">{{ advtamt }}</td>
    <td class="text-end fw-bold">{{ totaldisc_total }}</td>
    <td class="text-end fw-bold">{{ grand_total_before_gst }}</td>
    <td class="text-end fw-bold">{{ grand_total_gst }}</td>
    <td class="text-end fw-bold">{{ grand_total_amt }}</td>
    <td class="text-end fw-bold">{{ jamatotal }}</td>
    <td class="text-end fw-bold">{{ advtamt - jamatotal }}</td>
  </tr>
</tfoot>

    </table>
  </div>
</div>
